import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import hljs from 'highlight.js';
import { Marked, Renderer } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true,
  pure: true,
})
export class MarkdownPipe implements PipeTransform {
  private marked: Marked;

  constructor(private sanitizer: DomSanitizer) {
    // Create custom renderer to handle SVG code blocks
    const renderer = new Renderer();
    const originalCode = renderer.code.bind(renderer);
    renderer.code = (code) => {
      const { text, lang } = code;

      if (lang === 'mermaid') {
        // For mermaid diagrams, wrap in a div with mermaid class for rendering
        return `<div class="mermaid">${text}</div>`;
      }
      if (lang === 'svg') {
        // For SVG code blocks, embed the SVG directly
        return text;
      }
      // For other languages, use highlight.js
      if (lang) {
        const language = hljs.getLanguage(lang) ? lang : 'plaintext';
        const highlighted = hljs.highlight(text, { language }).value;
        return `<pre><code class="hljs language-${lang}">${highlighted}</code></pre>`;
      }
      return originalCode(code);
    };

    this.marked = new Marked({ renderer });

    this.marked.setOptions({
      breaks: true,
      gfm: true,
      // Allow custom renderers to return raw HTML without escaping
      // This is needed for SVG and mermaid diagrams to render properly
      silent: false,
    });
  }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    const html = this.marked.parse(value) as string;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
